import VueTimers from 'vue-timers';
import GalleryItem from './../GalleryItem'
import Banner from './../Banner'
import AdminUI from './../AdminUI'
import lightboxStore from '../Lightbox/LightboxStore'
import '../Lightbox/LightboxDirective';
import Lightbox from '../Lightbox'
import { blueyetiStates } from './../../utils/blueyetiStates'
import { sync } from 'vuex-pathify'
import axios from 'axios'


export default {
   name: 'gallery',
   components: {GalleryItem, Banner, Lightbox, AdminUI},
   mixins: [blueyetiStates],
   props: {
      plusButtonColors: Array,
   },
   data () {
      return {
         scrollPosition: 0,
         scrollSpeed: 100,
         prevTickDate: 0,
         bannerContent:{
            enabled: false,
            text: "Bienvenue sur le POPBook",
            background_color: "#f0f8ff",
            background_image: "./img/banner/banner_bgrd.jpg",
            font_size: 50,
            font_color: "#ffffff"
         },
         plusButtonOrder: [0, 3, 1, 4, 2],
         plusButton: {
            filename: "",
            thumbnail: "",
            color: "#00FF00",
            type: "button"},
            messages: [],
            gallery: [],
            adminGesture: {
               startOk: false,
               oldPos:{
                  x:0,
                  y:0,
               },
            }
         }
      },
      computed: {
         is_dev_mode:sync('is_dev_mode'),
         is_idle:sync('is_idle'),
         is_gallery_lightbox:sync('is_gallery_lightbox'),
         host_address:sync('host_address'),
         api_address:sync('api_address'),
         token:sync('token')

      },
      timers: {
         startAutoScroll: { time: 4000, autostart: false }, //4000
         adminGestureDelay: { time: 3000, autostart: false },
      },
      created () {

         // axios.get(this.api_address + 'settings').then((response) =>{
         //   console.log(response.data);
         // });
         this.getBanner();
         this.loadGallery();

      },
      mounted () {
         //console.log('plusButtonColors ' + this.plusButtonColors);
         //this.$refs.gallerySlides.swiper.update();
         this.$timer.start('startAutoScroll');
      },
      destroy () {
         cancelAnimationFrame(this.render);
         this.render = undefined;
      },
      watch: {
         lightboxState: function (val) {
            console.log(val);
            this.is_gallery_lightbox = val.visible;
         }
      },
      methods: {

         loadGallery: function(){
            const that=this;

            axios.post(this.api_address + 'gallery', {
               token: this.token
            }, {
               headers: {
                  'Content-Type': 'application/json',
                  Authorization: `Bearer ${process.env.VUE_APP_PUBLIC_API_TOKEN}`
               }
            })
            .then(function (response) {
               //console.log(response);
               var data = JSON.parse(response.data);
               that.messages = data.messages;
               that.onGalleryLoaded();
            })
            .catch(function (error) {
               console.log(error);
               that.onGalleryLoaded();
            });
         },

         onGalleryLoaded: function(){
            console.log('onGalleryLoaded ' + this.host_address);

            if(this.gallery.length > 0)
            {
               this.$eventHub.$emit('reset');
               this.gallery = [];
            }

            var that=this;

            this.messages.forEach(function(a) {
               if(a.thumbnail.substring(0, 2) == '..'){
                  //console.log('a.thumbnail ' + a.thumbnail);
                  if(that.is_dev_mode)
                  a.thumbnail = that.host_address + a.thumbnail.slice(2);
               }
               if(a.filename.substring(0, 2) == '..'){
                  if(that.is_dev_mode)
                  a.filename = that.host_address + a.filename.slice(2);
               }
            });

            // utilities to copy button
            function isObject(obj) {
               var type = typeof obj;
               return type === 'function' || type === 'object' && !!obj;
            };
            function iterationCopy(src) {
               let target = {};
               for (let prop in src) {
                  if (src.hasOwnProperty(prop)) {
                     // if the value is a nested object, recursively copy all it's properties
                     if (isObject(src[prop])) {
                        target[prop] = iterationCopy(src[prop]);
                     } else {
                        target[prop] = src[prop];
                     }
                  }
               }
               return target;
            }
            //console.log('messages' + this.messages);
            //console.log('messages' + this.messages);
            console.log('messages length' + this.messages.length);
            //this.messages = this.messages.reverse();
            var i, j = 0;
            var plusButtonIndex = 0;
            var plusColorsIndex = 0;
            // var messages = [];
            // for (i = 0 ; i < 50 ; i++)
            // {
            //    messages.push(this.messages[i]);
            // }
            // this.messages = [];
            // for (i = 0 ; i < 19 ; i++)
            // {
            //    this.messages.push(messages[i]);
            // }
            if(this.messages.length == 0)
            {
               var row = [];
               var button = iterationCopy(this.plusButton);
               button.color = this.plusButtonColors[plusColorsIndex];
               row.push(button);
               for (i = 0 ; i < this.messages.length ; i++)
               {
                  row.push(this.messages[i]);
               }
               this.gallery.push(row);
               console.log(this.gallery);
            }
            else {
               var nbRows =  Math.floor(Math.max(this.messages.length/4,20));
               //console.log("nbRows " + nbRows);
               if(this.bannerContent.enabled) {
                  //here get a multiple of 5 rows to get the same number of line between banners
                  nbRows =  Math.floor(nbRows/5) * 5;
                  console.log("nbRows2 " + nbRows);
               }
               for (i = 0 ; i < nbRows ; i++)
               {
                  var row = [];
                  var k = 0;
                  for (j = 0 ; j< 5 ; j++)
                  {
                     if (j == this.plusButtonOrder[plusButtonIndex])
                     {
                        var button = iterationCopy(this.plusButton);
                        button.color = this.plusButtonColors[plusColorsIndex];
                        //console.log('plusButton.color' + button.color);
                        row.push(button);
                        //console.log('plusButtonIndex ' + plusButtonIndex);
                        //console.log('plusButtonOrder ' + this.plusButtonOrder[plusButtonIndex]);
                     }
                     else {
                        //console.log('message ' + k + " id " + this.messages[i*4+k].message_id);
                        //row.push(this.messages[i*4+k]);
                        row.push(this.messages[(i*4+k) % this.messages.length]); // si pas assez d'images
                        k++;
                     }
                  }
                  plusButtonIndex++;
                  plusButtonIndex = plusButtonIndex%5;
                  plusColorsIndex++;
                  plusColorsIndex = plusColorsIndex%this.plusButtonColors.length;
                  this.gallery.push(row);
               }

               // duplicate all array

               this.gallery = this.gallery.concat(this.gallery);
               console.log('gallery Size' + this.gallery.length);
            }



         },
         startAutoScroll() {
            this.$timer.stop('startAutoScroll');
            this.render();
         },
         // Update car values
         render(){
            // Recursive call
            var now = Date.now() / 1000.0;
            if((now - this.prevTickDate) > 0 && (now - this.prevTickDate) < 1 && this.is_idle && !this.is_gallery_lightbox) {
               //console.log('scrollTop offset ' + (now - this.prevTickDate));
               //console.log('scrollTop offset ' + this.scrollSpeed *(now - this.prevTickDate));
               //console.log(this.scrollPosition);
               this.$refs.galleryDiv.scrollTop = this.scrollPosition + this.scrollSpeed * (now - this.prevTickDate);
            }
            this.prevTickDate = now;
            requestAnimationFrame(this.render.bind(this));



         },
         onMouseDown: function(e) {
            var x = 0;
            var y = 0;
            if(e.touches == null) {
               x = e.screenX;
               y = e.screenY;
            }
            else {
               x = e.touches[0].clientX;
               y = e.touches[0].clientY;
            }
            this.adminGesture.startOk = x < 150 && y > 900;
            console.log("onMouseDown pos " + x + " " + y);
            console.log("onMouseDown ok " + this.adminGesture.startOk);
            this.adminGesture.oldPos = { x:x, y:y};
            //this.gesture_start_pos = { x:e.screenX, y:e.screenY};
            if(this.adminGesture.startOk)
               this.$timer.start('adminGestureDelay');
         },
         onMouseUp: function(e) {
            this.$timer.stop('adminGestureDelay');
            this.adminGesture.startOk = false;
            console.log("onMouseUp");
         },
         onMouseMove: function(e) {
            var x = 0;
            var y = 0;
            //if(this.gesture_start_pos.x )adminGestureDelay
            if(e.touches == null) {
               x = e.screenX;
               y = e.screenY;
            }
            else {
               x = e.touches[0].clientX;
               y = e.touches[0].clientY;
            }
            //console.log("onMouseMove");
            if(this.adminGesture.startOk) { // && x > 1440) {
               var delta2 = (x - this.adminGesture.oldPos.x) * (x - this.adminGesture.oldPos.x) + (y - this.adminGesture.oldPos.y) * (y - this.adminGesture.oldPos.y);
               console.log("delta2 " + delta2);
               if(delta2 > 2.) {
                  this.adminGesture.startOk = false;
                  console.log("hand has move");
                  this.$timer.stop('adminGestureDelay');
                  //this.$timer.start('adminGestureDelay');
               }
               this.adminGesture.oldPos = { x:x, y:y};
            }
         },
         adminGestureDelay: function(e) {
            console.log("admin gesture timer end");
            this.byst_SetState('gallery/admin/code');
            //if(this.gesture_start_pos.x )
         },
         onScroll: function(e, position) {
            //if(position.scrollTop != this.scrollPosition)
            //console.log('scrolltop1 ' + position.scrollTop);
            this.scrollPosition = position.scrollTop;
            var topItem = this.scrollPosition / 216;
            var galleryBannersHeight = 0;
            if(this.bannerContent.enabled) {
               if((topItem % 7) < 1 || (topItem % 7) > 3) {
                  topItem = topItem - Math.floor((topItem + 6)/7) * 2; // substract previous banner total height
               }
               else { // when banner is on top, keep integer value of last item
                  topItem = Math.floor(topItem / 7) * 7 + 3 - Math.floor((topItem + 6)/7) * 2;
               }
               //console.log('topItem ' + topItem);
            }
            if(this.gallery.length > 5 && topItem >= (this.gallery.length) / 2) {
               this.scrollPosition = this.$refs.galleryDiv.scrollTop = topItem - this.gallery.length / 2; //add offset
               //console.log('scrolltop2 ' + position.scrollTop);
            }

         },



         onSlideChange: function(e){
            console.log('onSlideChange' + e);
         },
         onSlideTap: function(e){
            //this.$refs.gallerySlides.swiper.update();
            //console.log('onSlideTap', e, this.$refs.gallerySlides.swiper.clickedIndex);
         },

         onSliderProgress: function(e){
            //console.log('onSlideProgress ', e);
            var topItem =e * (this.gallery.length - 5);
            console.log('topItem ', topItem);
            //if(this.gallery.length > 5 && topItem >= this.gallery.length / 2)
            //this.$refs.gallerySlides.swiper.slideTo(0, 0);

            //this.$refs.backgroundSlides.swiper.mySwiper.slideToLoop()
            //this.$refs.gallerySlides.swiper.updateSlides();
         },

         onStickerTap: function(e){
            console.log('onStickerTap', e);
         },

         closeLightbox: function(){
            console.log('closeLightbox');
            this.$refs.lightbox.close();
         },
         reset: function(){
            console.log('reset gallery');
            this.$refs.lightbox.close();
            this.loadGallery();
         },
         getBanner: function() {
            var that = this;
            axios.post(this.api_address + 'banner', {
               token: this.token
            }, {
               headers: {
                  'Content-Type': 'application/json',
                  Authorization: `Bearer ${process.env.VUE_APP_PUBLIC_API_TOKEN}`
               }
            })
            .then(function (response) {
               console.log(response);
               var data = JSON.parse(response.data);
               that.bannerContent = data;
               if(data.background_image && data.background_image.substring(0, 2) == '..'){
                  if(that.is_dev_mode)
                  that.bannerContent.background_image = that.host_address + data.background_image.slice(2);
               }

            })
            .catch(function (error) {
               console.log(error);
            });

         },


      }
   }
